import ReactGA from 'react-ga4'

import { store } from '@/store/store'
import { PriceMapType } from '@/types/card'

import { initialPriceSources } from '../initialState'

import { SET_USER_STATE } from './types'

const cardmarketRegions = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'JP',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
]

const prependPriceSource = (priceSource: string, priceSources: Array<keyof PriceMapType>) =>
  [priceSource, priceSources[0], priceSources[1]] as Array<keyof PriceMapType>

const setRegion = async (region: string) => {
  const dispatch = store.dispatch
  const state = store.getState()

  try {
    let priceSources = state.user.priceSources
    if (state.user.region !== region && state.user.priceSources[0] !== initialPriceSources[2]) {
      if (region == 'CA') {
        priceSources = prependPriceSource('face2face', state.user.priceSources)
      } else if (region === 'MX') {
        priceSources = prependPriceSource('tcgl', state.user.priceSources)
      } else if (cardmarketRegions.includes(region)) {
        priceSources = prependPriceSource('cardmarket', state.user.priceSources)
      }
    }

    priceSources.map((source) =>
      ReactGA.event({
        action: 'Init Price Source',
        category: 'Pricing',
        label: `region:${region}|source:${source}`,
        nonInteraction: true,
      }),
    )

    dispatch({
      payload: {
        priceSources,
        region,
      },
      type: SET_USER_STATE,
    })
  } catch (err) {
    console.error(err)
  }
}

export default setRegion
